//eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {}

const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

const displayNotificationCount = (count) => {
  if (!count) {
    return ''
  } else if (count > 0 && count < 100) {
    return `(${count})`
  } else {
    return '(99+)'
  }
}

const setDocumentTitle = (count) => {
  const displayCount = displayNotificationCount(count)

  document.title = displayCount ? `${displayCount} Mango` : 'Mango'
}

const decodeBase64 = (base64: string) => {
  return atob(base64)
}

const isAccessTokenExpired = (accessToken: string) => {
  try {
    const { exp } = JSON.parse(decodeBase64(accessToken.split('.')[1]))
    const curTime = new Date().getTime()
    const expired = exp * 1000 < curTime
    return expired
  } catch {
    //token couldn't be parsed for some reason, return true on expiry.
    return true
  }
}

const isClickToCallName = (name: string) => {
  const regex = /^C2C-\+?[1-9]\d{1,14}$/
  return regex.test(name)
}

export {
  noop,
  openInNewTab,
  displayNotificationCount,
  setDocumentTitle,
  decodeBase64,
  isAccessTokenExpired,
  isClickToCallName,
}
